import FullscreenExitIcon from '@atlaskit/icon/core/fullscreen-exit';
import * as React from 'react';

export function SvgMinimize() {
  return <FullscreenExitIcon label="" testId="ads-refreshed-icon" />;
}
